import { Button, useToast } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';

interface CopyButtonProps {
  answer: string;
}

export const CopyButton = ({ answer }: CopyButtonProps) => {
  const { open: openToast } = useToast();

  const COPY_BUTTON_TEXT = I18n.t('js.learner.ai_search.copy');
  const COPY_TOOLTIP = I18n.t('js.learner.ai_search.copy_tooltip');
  const COPY_SUCCESS_MESSAGE = I18n.t('js.learner.ai_search.copy_success');
  const COPY_ERROR_MESSAGE = I18n.t('js.learner.ai_search.copy_error');

  const handleCopy = () => {
    if (answer && navigator.clipboard) {
      navigator.clipboard
        .writeText(answer)
        .then(() => {
          openToast({
            children: COPY_SUCCESS_MESSAGE,
          });
        })
        .catch(() => {
          openToast({
            children: COPY_ERROR_MESSAGE,
          });
        });
    }
  };

  return (
    <Button
      variant="text"
      size="sm"
      onClick={handleCopy}
      color="primary"
      leadingIconName="copy:regular"
      tooltip={{
        message: COPY_TOOLTIP,
        placement: 'top',
      }}
    >
      {COPY_BUTTON_TEXT}
    </Button>
  );
};
